<template>
  <div id="error">
    <h3 class="title">(404) Page NotFound</h3>
    <h3 class="sub-title">Sorry, your requested page isn't available</h3>
  </div>
</template>

<script>
export default {
  name: "Error"
};
</script>

<style scoped>
#error {
  margin-top: 10vh;
  padding: 10vh 0;
  height: 50vh;
}
</style>
